module.exports = __webpack_public_path__ + "static/media/1.e5876336.jpg";